module.exports = __webpack_public_path__ + "img/fruit_coffee.6923fb6e.png";